import React from 'react';
import { setSolvedExp } from '../../../api/api.js';

const ToExp = ({ id, number, randomPrefTo, randomUnit, exp, setExp, expSolution, checkExp }) => {
    const checkAnswer = () => {
        const solved = parseInt(exp) === expSolution;
        if (solved) {
            setSolvedExp(id)
        }
        console.log('SOLVED_TOEXP', solved);

        return solved;
    };

    return (
        <td className={ checkExp ? checkAnswer() ? 'true-answer' : 'false-answer' : undefined }>
            <div className="notation left num">{number}</div>
            <div className="notation right">
                <div className="exponent">&nbsp;· 10 <sup><input disabled={checkExp ? 'disabled' : undefined } className="inputExp" type="text" value={exp} onChange={e => setExp(e.target.value)} /></sup></div>
                &nbsp;
                <div className="unit">{randomPrefTo.letter}{randomUnit.letter}</div>
            </div>
        </td>
    )
}

export default ToExp;
